module.exports = __webpack_public_path__ + "img/documentsinactivehover.99e8c13d.svg";